/**
 * Navigation Helpers
 *
 * Learner navigation configuration for the main AppShell.
 * Parent, Teacher, and Admin portals use their own dedicated sidebars.
 */

import { BookOpen, BarChart3, Settings, Lightbulb, LucideIcon, Home, ClipboardCheck } from 'lucide-react';
export interface NavigationItem {
  id: string;
  label: string;
  icon: LucideIcon;
  isDev?: boolean;
}

// ── Learner navigation (the only role that uses AppShell's Sidebar/MobileNav) ──

const LEARNER_NAV: NavigationItem[] = [{
  id: 'home',
  label: 'Home',
  icon: Home
}, {
  id: 'modules',
  label: 'Mijn Werelden',
  icon: BookOpen
}, {
  id: 'progress',
  label: 'Voortgang',
  icon: BarChart3
}, {
  id: 'assessment',
  label: 'Toetsen',
  icon: ClipboardCheck
}, {
  id: 'learningLab',
  label: 'Oefenlab',
  icon: Lightbulb
}, {
  id: 'settings',
  label: 'Instellingen',
  icon: Settings
}];

/**
 * Get learner navigation items.
 *
 * Note: This always returns LEARNER_NAV. Parent/Teacher/Admin portals
 * have their own sidebars (TeacherSidebar, ParentSidebar, AdminSidebar)
 * and never reach this code path via AppShell.
 */
export function getLearnerNavItems(): NavigationItem[] {
  return LEARNER_NAV;
}